// assets
import { TeamOutlined, ShopOutlined, UserOutlined, UserSwitchOutlined } from '@ant-design/icons';

// type
import { NavItemType } from 'types/menu';

// icons
const icons = {
  TeamOutlined,
  ShopOutlined,
  UserOutlined,
  UserSwitchOutlined
};

// ==============================|| MENU ITEMS - USER ||============================== //

const user: NavItemType = {
  id: 'user-managment',
  title: 'user-managment',
  type: 'group',
  permissionKey: ['SUPER', 'LIST_CUSTOMERS', 'ARCHIVE_CUSTOMERS', 'LIST_SELLERS'],
  children: [
    {
      id: 'admins',
      title: 'admins',
      type: 'collapse',
      permissionKey: ['SUPER'],
      icon: icons.TeamOutlined,
      children: [
        {
          id: 'super-admins',
          title: 'super-admins',
          type: 'item',
          permissionKey: ['SUPER'],
          url: '/apps/user-managment/super-admins/list'
        },
        {
          id: 'admins',
          title: 'admins',
          type: 'item',
          permissionKey: ['SUPER'],
          url: '/apps/user-managment/admins/list'
        }
      ]
    },
    {
      id: 'sellers',
      title: 'sellers',
      type: 'item',
      permissionKey: ['LIST_SELLERS'],
      url: '/apps/user-managment/seller/list',
      icon: icons.ShopOutlined
    },
    {
      id: 'customers',
      title: 'customers',
      type: 'item',
      permissionKey: ['LIST_CUSTOMERS', 'ARCHIVE_CUSTOMERS'],
      url: '/apps/user-managment/customers/list',
      icon: icons.UserOutlined
    },
    {
      id: 'role',
      title: 'role',
      type: 'item',
      permissionKey: ['SUPER'],
      url: '/apps/user-managment/role/list',
      icon: icons.UserSwitchOutlined
    }
  ]
};

export default user;
